import tailwindContainerQueries from '@tailwindcss/container-queries'
import tailwindForms from '@tailwindcss/forms'
import tailwindTypography from '@tailwindcss/typography'

export default {
  darkMode: ['class', '[data-mode="dark"]'],
  prefix: 'tw-',
  content: [
    './app/javascript/**/*.{vue,js,ts,jsx,tsx,svg}',
    './app/views/**/*.{slim,erb}',
  ],
  theme: {
    extend: {
      transitionProperty: {
        visibility: 'opacity, visibility',
      },
      height: {
        max: 'max-content',
      },
      lineClamp: {
        16: '16',
      },
      fontSize: {
        xxs: '.625rem',
      },
    },
    fontFamily: {
      sans: ['Inter', 'sans-serif'],
    },
    // If you change screens here, please make sure that you also change screens here: app/javascript/mixins/useScreenWidth.js
    screens: {
      xs: '475px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
      '2xl': '1536px',
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      white: '#ffffff',
      black: '#000000',
      neutral: {
        50: '#F1F4F9',
        100: '#E7EBF1',
        200: '#D7DEE9',
        300: '#BEC7D7',
        400: '#98A2B2',
        500: '#6D798B',
        600: '#4E5B6D',
        700: '#374457',
        800: '#273243',
        900: '#141F2F',
      },
      primary: {
        50: '#E8F1FE',
        100: '#DAEAFF',
        200: '#BCD8FF',
        300: '#92BEFF',
        400: '#2D7DF9',
        500: '#006CFF',
        600: '#005BED',
        700: '#0053D6',
        800: '#004BC0',
        900: '#003480',
      },
      secondary: {
        50: '#EDE3FF',
        100: '#D4BDFF',
        200: '#C2A0FF',
        300: '#A97AFF',
        400: '#9358FF',
        500: '#813CFF',
        600: '#7630F5',
        700: '#6A25E7',
        800: '#5B18D1',
        900: '#4D0DBC',
      },
      success: {
        50: '#E1F6E8',
        100: '#B4E8C7',
        200: '#91E1AE',
        300: '#72CF93',
        400: '#4AC074',
        500: '#24A953',
        600: '#18A44A',
        700: '#079C3C',
        800: '#008E33',
        900: '#00772B',
      },
      warning: {
        50: '#FFF7D1',
        100: '#FFEE99',
        200: '#FFE45E',
        300: '#FFDE3E',
        400: '#FDDA2E',
        500: '#FFD91F',
        600: '#FFD400',
        700: '#F0C700',
        800: '#D2AF00',
        900: '#A48800',
      },
      error: {
        50: '#FFE3E6',
        100: '#FFCACF',
        200: '#FF9FA9',
        300: '#FF6777',
        400: '#F23B4E',
        500: '#DA1A2E',
        600: '#BB192A',
        700: '#A81323',
        800: '#94101E',
        900: '#760915',
      },
    },
    boxShadow: {
      sm: '0px 2px 2px 0px #0000000D',
      DEFAULT: '0px 2px 4px 0px #0F172A26',
      md: '0px 3px 12px 0px #0000001A',
      lg: '0px 8px 12px 0px #0000001A',
      xl: '0px 10px 16px 0px #0F172A1A',
      xxl: '0px 16px 24px 0px #0F172A1A',
    },
  },
  plugins: [
    tailwindContainerQueries,
    tailwindForms,
    tailwindTypography,
    function ({ addVariant }) {
      addVariant('children', '& > *')
    },
  ],
}
